import AbsComponent from '../../common/components/AbsComponent';
import ClassfilterTempl from './ClassfilterTempl';

/**
 * Classfilter class
 * @category testApp
 */
class Classfilter extends AbsComponent{
    constructor(_store={}){
        super(_store);
        this.store.getClassInfoData(this.render.bind(this));
    }

    setting(_serverType){
        let classsFilterOptions = $('#select-classId option');
        for(let i=1;i<classsFilterOptions.length;i++){
            let serverTypeArray = $(classsFilterOptions[i]).attr('data-server-type').split(',');
            if(_serverType === undefined){
                classsFilterOptions[i].removeAttribute('disabled');
            }
            else if(false === serverTypeArray.includes(_serverType)){
                classsFilterOptions[i].setAttribute('disabled', 'true');
            }
            else{
                classsFilterOptions[i].removeAttribute('disabled');
            }
        }
    }

    render(_jsonData = {}){
        $('#select-classId').html(ClassfilterTempl.getClassFilterTempl(_jsonData));
        this.addEvents();
    }

    addEvents(_d){
        $(document).on('change', '#select-classId', (e)=>{
            let select_name = $(e.currentTarget).children("option:selected").text();
            let label_object = $(e.currentTarget).parent("label");
            let select_object = $(e.currentTarget);
            label_object.text(select_name);
            label_object.append(select_object);
            $('#select-classId').trigger('result_change');
        });
    }
}

export default Classfilter;